export enum ProductStatusEnum {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  REFUSED = 'REFUSED',
  REQUESTED = 'REQUESTED',
  DEACTIVATED = 'DEACTIVATED',
  ACTIVE = 'ACTIVE',
  NEW = 'NEW',
  WAITING_MODIFICATION_APPROVAL = 'WAITING_MODIFICATION_APPROVAL',
  WAITING_CREATION_APPROVAL = 'WAITING_CREATION_APPROVAL'
}

export namespace ProductStatusEnum {
  export function getClassName(): string {
    return 'ProductStatusEnum';
  }
}
